import Vue from 'vue'
import axios from 'axios'
const vm = new Vue()
// 引入md5加密
// import md5 from 'js-md5'

// 创建axios实例
const _axios = axios.create({
  // 生产
  baseURL: process.env.NODE_ENV === 'development' ? '/hussarApi' : '//zt.bjgas.com/bjgas-server'
  // 测试
  // baseURL: process.env.NODE_ENV === 'development' ? '/hussarApi' : '//zttest.bjgas.com/bjgas-server'
  // timeout: 60 * 1000 // 设置超时时间为60s
})

// 请求拦截
_axios.interceptors.request.use(config => {
  const token = 'Bearer ' + window.localStorage.token
  if (token) {
    config.headers.Authorization = token
  }
  return config
})

// 响应拦截
_axios.interceptors.response.use(response => {
  if (response.status === 401) {
    // 清除本地存储数据
    window.localStorage.clear()
    // 返回登录页面
    // vm.$router.push({ path: '/' })
  }
  if (response.status === 404) {
    console.log('404：找不到资源')
  }
  return response
}, error => {
  if (error.status === 401) {
    // 清除本地存储数据
    localStorage.clear()
    // 返回登录页面
    // vm.$router.push({ path: '/' })
  }
  if (error.status === 404) {
    console.log('404：找不到资源')
  }
  return Promise.reject(error.response)
})
/**
 * 挂载到vue
 */
Vue.prototype.$http = {
  /**
   * get请求
   */
  get: (url, params) => _axios.get(url, params),
  /**
   * post请求
   */
  post: (url, params) => {
    return _axios({
      method: 'post',
      url: url,
      data: params,
      headers: {
        'Content-Type': 'application/json',
        'x-requested-with': 'AxiosHttpRequest'
      }
    })
  }
}
